import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const uploadBundles = {
  name: "uploadBundles" as const,
  input: z.object({
    teamId: z.string(),
    bundles: z.array(
      z.object({
        parentSku: z.string(),
        childSkus: z.array(z.string()),
        returnTypes: z.array(createEnum(ReturnTypeEnum)).nullish(),
      }),
    ),
    replaceExisting: z.boolean(),
  }),
  output: z.object({ success: z.boolean(), count: z.number() }),
};
